import { IProject } from 'screens/Projects/projects.types'
import Button from 'shared/Buttons/Button/Button'
import Card from 'shared/Cards/Card'
import { useState } from 'react'
import SelectRolesModal from '../../SelectRolesModal'
import useSlotTeamMemberRoles from 'screens/Projects/hooks/useSlotMemberRoles'
import { useRecoilValue } from 'recoil'
import selfTeamsAtom from 'screens/Auth/components/InitProvider/selfTeams.atom'
import authAtom from 'screens/Auth/auth.atom'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import useIsLeaveProjectPossible from 'screens/Projects/hooks/useIsLeaveProjectPossible'
import projectsApi from 'screens/Projects/projects.api'
import useIsProjectActive from 'screens/Projects/hooks/useIsProjectActive'

interface IProps {
  project: IProject
  onLeft: (project: IProject) => void
}

const ProjectRolesCard = (props: IProps) => {
  const [isOpenRolesModal, setIsOpenRolesModal] = useState(false)

  const isLeavePossible = useIsLeaveProjectPossible(props.project)

  const userId = useRecoilValue(authAtom).user.id
  const selfTeams = useRecoilValue(selfTeamsAtom).items
  const activeTeam = selfTeams[0]

  const isProjectActive = useIsProjectActive(props.project)

  const { wait, loading } = useHttpLoader()

  const selfTeamSlot = props.project.slots?.find((slot) => slot.claimedBy?.id === activeTeam?.id)
  const isTeamOwner = activeTeam?.ownerId === userId

  const { slotTeamMemberRoles, setSlotTeamMemberRoles } = useSlotTeamMemberRoles(props.project.id, selfTeamSlot?.id)

  const openRolesModal = () => {
    setIsOpenRolesModal(true)
  }

  const canChangeRoles = !!selfTeamSlot && isTeamOwner && isProjectActive

  const handleLeaveProject = () => {
    if (!isLeavePossible) return

    wait(projectsApi.leaveProject(props.project.id, selfTeamSlot.id), (resp) => {
      if (resp.status === 'success') {
        const updatedProject = {
          ...props.project,
          slots: props.project.slots.map((s) => (s.id === selfTeamSlot.id ? resp.body : s)),
        }
        props.onLeft(updatedProject)
      }
    })
  }

  if (!selfTeamSlot) {
    return null
  }

  return (
    <Card type='normal' style={{ height: '100%', width: '100%' }}>
      {isOpenRolesModal && canChangeRoles && (
        <SelectRolesModal
          onClose={() => setIsOpenRolesModal(false)}
          team={activeTeam}
          slotTeamMemberRoles={slotTeamMemberRoles}
          onSelect={setSlotTeamMemberRoles}
          projectId={props.project.id}
          slot={selfTeamSlot}
        />
      )}
      <div className='flex-lines'>
        <h2 className='text--caption-l'>Роли в команде</h2>
        <p className='text--body-m text--alert' style={{ textAlign: 'left' }}>
          Важно! Выбор роли влияет на доступный контент в базе знаний. Пожалуйста, выбирайте вашу роль внимательно.
        </p>
        <div className='auto-grid-min-300'>
          {slotTeamMemberRoles.map((member) => (
            <div key={member.userId}>
              <p className='text--body-m text--secondary text-700'>{member.userName}</p>
              <p className='text--body-m text--primary '>{member.roleName}</p>
            </div>
          ))}
        </div>
        <div className='form-footer'>
          <div className='flex-space-between'>
            {canChangeRoles && (
              <Button
                theme='primary'
                style={{ width: 'fit-content' }}
                onClick={openRolesModal}
                disabled={!canChangeRoles}
              >
                Указать роли
              </Button>
            )}
            {isLeavePossible && (
              <Button loading={loading} theme='danger' style={{ width: 'fit-content' }} onClick={handleLeaveProject}>
                Выйти из проекта
              </Button>
            )}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default ProjectRolesCard
